import script from "./DBreadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./DBreadcrumb.vue?vue&type=script&setup=true&lang=js"

import "./DBreadcrumb.vue?vue&type=style&index=0&id=a38f5086&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a38f5086"]])

export default __exports__